export default __webpack_public_path__ + "static/media/touchThree.fc49de4a.svg";